import { Body1, Body2 } from '@cian/ui-kit';
import React from 'react';
import clsx from 'clsx';
import { Mapper } from '../../AiSummaryModalDesktop/utils';
import * as styles from './styles.css';

export interface IFactRowProps {
  title: string | null;
  subtitle?: string | null;
  imagePath: string | null;
  isMobile?: boolean;
}

export function FactRow({ title, subtitle, imagePath, isMobile }: IFactRowProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['title-row']} data-testid="fact-row-title">
        <div className={clsx(styles['icon-wrapper'], isMobile && styles['icon-wrapper-mobile'])}>
          <Mapper icon={imagePath} />
        </div>
        <div className={styles['text-wrapper']}>
          <Body1>{title}</Body1>
          {subtitle && <Body2 color="text-secondary-default">{subtitle}</Body2>}
        </div>
      </div>
    </div>
  );
}
